import { useMemo } from 'react';
import { Stack, StackProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAdminInvoiceQuery } from '../../../../api/gql';
import { ContactInfoBox } from '../../../../modules/admin/invoice/ContactInfoBox';

type Props = {
  invoiceId: string;
  transNs?: string;
  keyPrefix?: string;
} & StackProps;

export const InvoiceContactsInfoBox = ({ invoiceId, transNs, keyPrefix, ...rest }: Props) => {
  const { data, isLoading, isError } = useAdminInvoiceQuery({
    id: invoiceId,
  });

  const customer = useMemo(() => data?.adminInvoice.customer, [data?.adminInvoice.customer]);
  const owner = useMemo(() => data?.adminInvoice.owner, [data?.adminInvoice.owner]);
  const { t } = useTranslation(transNs, { keyPrefix });

  return (
    <Stack direction={'row'} flexWrap={'wrap'} gap={2} {...rest}>
      <ContactInfoBox
        title={t('customer')}
        contact={customer}
        isLoading={isLoading}
        isError={isError}
        sx={{ flex: 1 }}
      />
      <ContactInfoBox
        title={t('owner')}
        contact={{ ...owner, name: `${owner?.firstName} ${owner?.lastName}` }}
        isLoading={isLoading}
        isError={isError}
        sx={{ flex: 1 }}
      />
    </Stack>
  );
};
